import { useTranslation } from '@mint-lib/i18n';

import { TableEditCellProps } from './types.js';
import CurrencyVariant from './Variants/CurrencyVariant.jsx';
import DateVariant from './Variants/DateVariant.jsx';
import GoalVariant from './Variants/GoalVariant.jsx';
import NumberVariant from './Variants/NumberVariant.jsx';
import PercentVariant from './Variants/PercentVariant.jsx';
import TextVariant from './Variants/TextVariant.jsx';

const useEditCellVariant = (props: TableEditCellProps) => {
  const { t } = useTranslation('@myn/planning');

  const getPlaceholder = () => {
    if (props.disabled) {
      return '';
    }

    return props.placeholder || t('Insert values');
  };

  const preparedPlaceholder = getPlaceholder();

  const renderFormattedField = () => {
    switch (props.variant) {
      case 'number': {
        const { scale, value, decimalLimit, prefix } = props;
        return (
          <NumberVariant
            scale={scale}
            value={value}
            decimalLimit={decimalLimit}
            placeholder={preparedPlaceholder}
            prefix={prefix}
          />
        );
      }
      case 'percent': {
        const { scale, value, decimalLimit } = props;
        return (
          <PercentVariant
            scale={scale}
            value={value}
            decimalLimit={decimalLimit}
            placeholder={preparedPlaceholder}
          />
        );
      }
      case 'currency': {
        const { scale, currency, value, decimalLimit } = props;
        return (
          <CurrencyVariant
            scale={scale}
            currency={currency}
            value={value}
            decimalLimit={decimalLimit}
            placeholder={preparedPlaceholder}
          />
        );
      }
      case 'date': {
        const { scale, value } = props;
        return (
          <DateVariant
            scale={scale}
            value={value}
            placeholder={preparedPlaceholder}
          />
        );
      }
      case 'goal': {
        const { scale, currency, value } = props;
        return (
          <GoalVariant
            scale={scale}
            currency={currency}
            value={value}
            placeholder={preparedPlaceholder}
          />
        );
      }
      case 'text':
      default: {
        const { scale, value } = props;
        return (
          <TextVariant
            scale={scale}
            value={value}
            placeholder={preparedPlaceholder}
          />
        );
      }
    }
  };

  return { renderFormattedField };
};

export default useEditCellVariant;
